export enum NoticeType {
  OverDueConstructionUpdates = 1,
  UnreadMessages = 2,
}
